/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ScholarshipTypeFileRequestViewModel } from "../types/ScholarshipTypeFileRequestViewModel.ts";

export const scholarshipTypeFileRequestViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do documento (0 para novo).")),
  description: z.string().describe("Nome do documento.").nullish(),
  instruction: z
    .string()
    .describe("Instruções de anexação do documento. Opcional.")
    .nullish(),
  templateFile: z
    .string()
    .describe(
      "Nome do arquivo-modelo já armazenado (mantém o arquivo atual). Opcional.",
    )
    .nullish(),
  templateFileName: z
    .string()
    .describe("Nome original do arquivo-modelo (com extensão). Opcional.")
    .nullish(),
  templateFileUpload: z
    .instanceof(File)
    .describe(
      "Arquivo-modelo enviado (upload multipart). Preencha para adicionar/substituir o template. Opcional.",
    )
    .nullish(),
  isMandatory: z.optional(
    z.boolean().describe("Indica se o envio deste documento é obrigatório."),
  ),
  generateFormLink: z.optional(
    z
      .boolean()
      .describe("Indica se deve gerar link de formulário para o documento."),
  ),
  generateCandidatePortalLink: z.optional(
    z
      .boolean()
      .describe(
        "Indica se deve gerar link do portal do candidato para o documento.",
      ),
  ),
  active: z.optional(z.boolean().describe("Indica se o documento está ativo.")),
}) as unknown as ToZod<ScholarshipTypeFileRequestViewModel>;
